// import React, { useEffect, useState } from "react";
// import { CloudArrowUpIcon } from "@heroicons/react/24/solid";
// import ServiceProvider from "../../Images/Service Provider.png";
// import ClipboardDocumentListIcon from "../../Images/ClipboardDocumentListIcon.png";
// import LandingNavbar from "../navbar/LandingNavbar";
// import Footer from "../../pages/Footer";
// import { Legend } from "@headlessui/react";

// const tabs = [
//   "Basic Details",
//   "Service Details",
//   "ekyc",
//   "Video ekyc",
//   "Payment",
//   "Approval",
//   "Account Details",
// ];

// export default function ServiceProviderSignupForm() {
//   const [activeTab, setActiveTab] = useState(tabs[0]);
//   const [formData, setFormData] = useState({});
//   const [convicted, setConvicted] = useState(null);
//   const [otpTimer, setOtpTimer] = useState(60);
//   const [isTimerActive, setIsTimerActive] = useState(false);
//   const [approvalId, setApprovalId] = useState("");

//   const sendVideoLink = () => {
//     // TODO: hook up your Video eKYC API here
//     console.log(
//       "Video eKYC link sent to:",
//       formData.videoMobile,
//       formData.videoEmail
//     );
//   };

//   // start countdown when isTimerActive
//   useEffect(() => {
//     let interval;
//     if (isTimerActive && otpTimer > 0) {
//       interval = setInterval(() => {
//         setOtpTimer((t) => t - 1);
//       }, 1000);
//     }
//     if (otpTimer === 0) {
//       setIsTimerActive(false);
//     }
//     return () => clearInterval(interval);
//   }, [isTimerActive, otpTimer]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleNext = (e) => {
//     e.preventDefault();
//     const idx = tabs.indexOf(activeTab);
//     if (idx < tabs.length - 1) {
//       setActiveTab(tabs[idx + 1]);
//     }
//   };

//   const handlePrevious = () => {
//     const idx = tabs.indexOf(activeTab);
//     if (idx > 0) {
//       setActiveTab(tabs[idx - 1]);
//     }
//   };

//   // OTP handlers (stubs)
//   const sendOtp = () => {
//     // TODO: integrate Aadhaar OTP API
//     setOtpTimer(60);
//     setIsTimerActive(true);
//   };
//   const submitOtp = () => {
//     // TODO: verify OTP
//   };
//   const resendOtp = () => {
//     sendOtp();
//   };

//   // format timer as MM:SS
//   const formatTimer = () => {
//     const m = String(Math.floor(otpTimer / 60)).padStart(2, "0");
//     const s = String(otpTimer % 60).padStart(2, "0");
//     return `${m}:${s}`;
//   };

//   const handleCheckStatus = (e) => {
//     e.preventDefault();
//     // TODO: call your approval-status API with `approvalId`
//     console.log("Checking status for:", approvalId);
//   };
//   const handlePayment = (e) => {
//     e.preventDefault();
//     // TODO: call your approval-status API with `approvalId`
//     console.log("Checking status for:", Payment);
//   };

//   const renderInput = (label, name, type = "text", options) => (
//     <div className="w-full">
//       <label className="block text-sm font-medium text-gray-700 mb-1">
//         {label}
//       </label>
//       {type === "select" ? (
//         <select
//           name={name}
//           value={formData[name] || ""}
//           onChange={handleChange}
//           className="mt-1 block w-full border-b-2 border-gray-300 focus:outline-none focus:ring-0"
//         >
//           <option value="">Select</option>
//           {options.map((opt) => (
//             <option key={opt} value={opt}>
//               {opt}
//             </option>
//           ))}
//         </select>
//       ) : (
//         <input
//           name={name}
//           type={type}
//           value={formData[name] || ""}
//           onChange={handleChange}
//           className="mt-1 block w-full border-b-2 border-gray-300 focus:outline-none focus:ring-0"
//         />
//       )}
//     </div>
//   );

//   const renderFileUpload = (label, name) => {
//     const file = formData[name];
//     return (
//       <label className="relative w-full h-12 border-2 border-dashed border-blue-200 rounded-lg flex items-center justify-between px-4 cursor-pointer">
//         {/* show file name once selected */}
//         <span className={`text-sm ${file ? "text-gray-700" : "text-blue-500"}`}>
//           {file ? file.name : label}
//         </span>
//         {/* blue-background icon */}
//         <div className="p-2 bg-blue-100 rounded">
//           <CloudArrowUpIcon className="w-4 h-4 text-blue-500" />
//         </div>
//         <input
//           type="file"
//           name={file}
//           className="absolute inset-0 w-full h-full opacity-0"
//           onChange={handleChange}
//         />
//       </label>
//     );
//   };

//   return (
//     <>
//       <LandingNavbar />
//       <div className="flex flex-col min-h-screen w-full bg-gray-50">
//         <div className="flex-1 overflow-auto py-6">
//           <div className="w-full max-w-full mx-auto px-4 sm:px-6 lg:px-8">
//             <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
//               {/* Header */}
//               <div className="flex items-center mb-6">
//                 <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
//                   <img
//                     src={ServiceProvider}
//                     alt="Service Provider"
//                     className="w-10 h-10"
//                   />
//                 </div>
//                 <h2 className="ml-4 text-2xl font-semibold">
//                   Create New Account As:{" "}
//                   <span className="font-bold">Service Provider</span>
//                 </h2>
//               </div>

//               {/* Tabs */}
//               <div className="border-b mb-8">
//                 <nav className="-mb-px flex flex-wrap sm:flex-nowrap space-x-4">
//                   {tabs.map((tab) => (
//                     <button
//                       key={tab}
//                       onClick={() => setActiveTab(tab)}
//                       className={`pb-2 text-sm font-medium whitespace-nowrap ${
//                         activeTab === tab
//                           ? "border-b-2 border-blue-500 text-blue-600"
//                           : "text-gray-500 hover:text-gray-700"
//                       }`}
//                     >
//                       {tab}
//                     </button>
//                   ))}
//                 </nav>
//               </div>

//               {/* Basic Details */}
//               {activeTab === "Basic Details" && (
//                 <form className="space-y-8" onSubmit={handleNext}>
//                   {/* Row 1 */}
//                   <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//                     {renderInput("First Name", "firstName")}
//                     {renderInput("Middle Name", "middleName")}
//                     {renderInput("Last Name", "lastName")}
//                     {renderInput("Select Gender", "gender", "select", [
//                       "Male",
//                       "Female",
//                       "Other",
//                     ])}
//                     <div className="w-full">
//                       <label className="block text-sm font-medium mb-1">
//                         Date Of Birth
//                       </label>
//                       <input
//                         name="dob"
//                         type="date"
//                         value={formData.dob || ""}
//                         onChange={handleChange}
//                         className="mt-1 block w-full border-b-2 border-gray-300 focus:outline-none focus:ring-0"
//                       />
//                     </div>
//                   </div>

//                   {/* Row 2 */}
//                   <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//                     {renderInput("Mobile No.", "mobile")}
//                     {renderInput("Whatsapp No", "whatsapp")}
//                     {renderInput("Email ID", "email", "email")}
//                     {renderInput("ID Type", "idType", "select", [
//                       "Passport",
//                       "Aadhaar",
//                       "Driver License",
//                     ])}
//                     {renderInput("ID No.", "idNo")}
//                   </div>

//                   {/* Row 3 */}
//                   <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//                     {renderInput("Relation Type", "relation")}
//                     {renderInput("Full Name", "relatedFullName")}
//                     {renderInput("Category", "category", "select", [
//                       "Cat A",
//                       "Cat B",
//                       "Cat C",
//                     ])}
//                     {renderInput("Religion", "religion", "select", [
//                       "Hindu",
//                       "Muslim",
//                       "Christian",
//                       "Other",
//                     ])}
//                   </div>

//                   {/* Address */}
//                   <div>
//                     <h3 className="text-md font-medium mb-4">
//                       Address Details :
//                     </h3>
//                     <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//                       {renderInput("Country", "country", "select", [
//                         "India",
//                         "USA",
//                         "Other",
//                       ])}
//                       {renderInput("District", "district")}
//                       {renderInput("State", "state")}
//                       {renderInput("Village/Town/City", "city")}
//                       {renderInput("House No./Flat", "house")}
//                     </div>
//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
//                       {renderInput("Landmark", "landmark")}
//                       {renderInput("Street", "street")}
//                       {renderInput("Pincode", "pincode")}
//                     </div>
//                   </div>

//                   {/* File Uploads */}
//                   <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//                     {renderFileUpload("Upload Domicile")}
//                     {renderFileUpload("Upload Id Card")}
//                     {renderFileUpload("Upload Document")}
//                     {renderFileUpload("Upload Document")}
//                   </div>

//                   {/* Next */}
//                   <div className="flex justify-center mt-6">
//                     <button
//                       type="submit"
//                       className="px-8 py-2 bg-blue-500 text-white font-medium rounded-full hover:bg-blue-600"
//                     >
//                       Next
//                     </button>
//                   </div>
//                 </form>
//               )}

//               {/* Service Details */}
//               {activeTab === "Service Details" && (
//                 <form onSubmit={handleNext} className="space-y-6">
//                   {/* Work Place */}
//                   <div>
//                     <h3 className="text-md font-medium mb-2">Work Place :</h3>
//                     <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//                       {renderInput("District", "district", "select", [
//                         "A",
//                         "B",
//                         "C",
//                       ])}
//                       {renderInput("SRO", "sro", "select", [
//                         "SRO1",
//                         "SRO2",
//                         "SRO3",
//                       ])}
//                       {renderInput("License No.", "licenseNo")}
//                       {renderInput("Renew Year", "renewYear", "date")}
//                     </div>
//                   </div>

//                   {/* Conviction Question */}
//                   <fieldset>
//                     <legend className="text-md font-medium mb-2">
//                       Has been convicted of any criminal offense or removed from
//                       government service?
//                     </legend>
//                     <div className="flex items-center space-x-6 mb-2">
//                       {["yes", "no"].map((opt) => (
//                         <label key={opt} className="inline-flex items-center">
//                           <input
//                             type="radio"
//                             name="convicted"
//                             value={opt}
//                             checked={convicted === opt}
//                             onChange={() => setConvicted(opt)}
//                             className="form-radio h-4 w-4 text-blue-600"
//                           />
//                           <span className="ml-2 capitalize">{opt}</span>
//                         </label>
//                       ))}
//                     </div>
//                     {convicted === "yes" && (
//                       <textarea
//                         name="convictionDetails"
//                         rows={3}
//                         value={formData.convictionDetails || ""}
//                         onChange={handleChange}
//                         placeholder="Please Give Details"
//                         className="block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 p-2"
//                       />
//                     )}
//                   </fieldset>

//                   {/* Declaration */}
//                   <label className="inline-flex items-start">
//                     <input
//                       type="checkbox"
//                       name="declaration"
//                       checked={!!formData.declaration}
//                       onChange={handleChange}
//                       className="form-checkbox h-5 w-5 text-blue-600"
//                     />
//                     <span className="ml-3 text-sm">
//                       I declare that I have carefully read the Uttar Pradesh
//                       document writers licencing rules, 1997 and the conditions
//                       of licence in Form 2 and I hereby agree to abide by them.
//                     </span>
//                   </label>

//                   {/* File Uploads */}
//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                     {renderFileUpload("Upload Certificate", "certificate")}
//                     {renderFileUpload("Upload Photo", "photo")}
//                   </div>

//                   {/* Prev / Next */}
//                   <div className="flex justify-center space-x-4 mt-4">
//                     <button
//                       type="button"
//                       onClick={handlePrevious}
//                       className="w-32 py-2 border-2 border-blue-500 text-blue-500 rounded-full"
//                     >
//                       Previous
//                     </button>
//                     <button
//                       type="submit"
//                       className="w-32 py-2 bg-blue-500 text-white rounded-full"
//                     >
//                       Next
//                     </button>
//                   </div>
//                 </form>
//               )}

//               {/* ekyc */}
//               {activeTab === "ekyc" && (
//                 <form onSubmit={handleNext} className="space-y-6">
//                   {/* Aadhaar input + Send OTP */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Enter Your Aadhaar no.
//                     </label>
//                     <div className="flex items-center space-x-4 w-1/3">
//                       <input
//                         name="aadhaar"
//                         type="text"
//                         placeholder="Enter"
//                         value={formData.aadhaar || ""}
//                         onChange={handleChange}
//                         className="flex-1 border-b-2 border-gray-300 focus:outline-none focus:ring-0 py-2"
//                       />
//                       <button
//                         type="button"
//                         onClick={sendOtp}
//                         disabled={isTimerActive}
//                         className={`px-6 py-2 font-medium rounded-full ${
//                           !isTimerActive
//                             ? "bg-blue-500 text-white hover:bg-blue-600"
//                             : "bg-gray-300 text-gray-600 cursor-not-allowed"
//                         }`}
//                       >
//                         Send OTP
//                       </button>
//                     </div>
//                   </div>

//                   {/* Declarations */}
//                   <div className="bg-gray-100 p-4 rounded space-y-3 text-sm text-gray-700">
//                     <label className="flex items-start">
//                       <input
//                         type="checkbox"
//                         name="consentAuth"
//                         checked={formData.consentAuth || false}
//                         onChange={handleChange}
//                         className="mt-1 h-4 w-4 text-blue-600"
//                       />
//                       <span className="ml-2">
//                         I Hereby State That I Have No Objection In
//                         Authentication Myself With Aadhaar Based Authentication
//                         System and Consent to Providing My Aadhaar Number,
//                         Biometric and/or One-time Password (OTP) Data for
//                         Aadhaar Based Authentication for the Purposes of
//                         Availing Benefits of E-registration and E-stamp. I
//                         understand That the Aadhaar Number, Biometric and/or OTP
//                         I Provide for Authentication Shall Be Used
//                         <ol className="list-decimal list-inside ml-4 mt-2">
//                           <li>For Authenticating My Identity</li>
//                           <li>For Authenticating Property Ownership</li>

//                           <li>
//                             For De-Duplication within Verticals of IGRS
//                             (Inspector General of Registration and Stamps) and
//                             Other Integrated Departments (UADD (Directorate of
//                             Urban Administration), CLR (Commissioner Land
//                             Records and Settlement))
//                           </li>
//                         </ol>
//                       </span>
//                     </label>
//                     <label className="flex items-start">
//                       <input
//                         type="checkbox"
//                         name="understand"
//                         checked={formData.understand || false}
//                         onChange={handleChange}
//                         className="mt-1 h-4 w-4 text-blue-600"
//                       />
//                       <span className="ml-2">
//                         I understand that IGRS (Inspector General of
//                         Registration and Stamps), UADD (Directorate of Urban
//                         Administration), CLR (Commissioner Land Records and
//                         Settlement) and T&CP (Director of Town and Country
//                         Planning) shall ensure security and confidentiality of
//                         my personal identity data provided for the purpose of
//                         Aadhaar based authentication
//                       </span>
//                     </label>
//                   </div>

//                   {/* OTP inputs + Submit */}
//                   <div className="space-y-4">
//                     <label className="block text-sm font-medium text-gray-700">
//                       Enter OTP
//                     </label>
//                     <div className="flex space-x-2">
//                       {Array.from({ length: 6 }).map((_, idx) => (
//                         <input
//                           key={idx}
//                           name={`otp${idx}`}
//                           type="text"
//                           maxLength={1}
//                           value={formData[`otp${idx}`] || ""}
//                           onChange={handleChange}
//                           className="w-12 h-12 text-center border-b-2 border-gray-300 focus:outline-none focus:ring-0"
//                         />
//                       ))}
//                     </div>
//                     <button
//                       type="button"
//                       onClick={submitOtp}
//                       className="px-6 py-2 bg-blue-500 text-white font-medium rounded-full hover:bg-blue-600"
//                     >
//                       Submit OTP
//                     </button>
//                     <div className="flex items-center space-x-4 text-sm">
//                       <button
//                         type="button"
//                         onClick={resendOtp}
//                         className="text-blue-500"
//                       >
//                         Resend OTP
//                       </button>
//                       <span>{formatTimer()}</span>
//                     </div>
//                   </div>

//                   {/* Prev / Next */}
//                   <div className="flex justify-center space-x-4 mt-6">
//                     <button
//                       type="button"
//                       onClick={handlePrevious}
//                       className="w-32 py-2 border-2 border-blue-500 text-blue-500 rounded-full"
//                     >
//                       Previous
//                     </button>
//                     <button
//                       type="submit"
//                       className="w-32 py-2 bg-blue-500 text-white font-medium rounded-full hover:bg-blue-600"
//                     >
//                       Next
//                     </button>
//                   </div>
//                 </form>
//               )}

//               {/* VIDEO EKYC */}
//               {activeTab === "Video ekyc" && (
//                 <form onSubmit={handleNext} className="space-y-6">
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:w-1/3">
//                     {renderInput("Enter mobile no.", "videoMobile")}
//                     {renderInput("Enter Email Id", "videoEmail", "email")}
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       onClick={sendVideoLink}
//                       className="px-6 py-2 bg-blue-500 text-white font-medium rounded-full hover:bg-blue-600"
//                     >
//                       Send Video eKYC link
//                     </button>
//                   </div>
//                   <div className="flex justify-center space-x-4 mt-6">
//                     <button
//                       type="button"
//                       onClick={handlePrevious}
//                       className="w-32 py-2 border-2 border-blue-500 text-blue-500 rounded-full"
//                     >
//                       Previous
//                     </button>
//                     <button
//                       type="submit"
//                       className="w-32 py-2 bg-blue-500 text-white font-medium rounded-full hover:bg-blue-600"
//                     >
//                       Verify & Next
//                     </button>
//                   </div>
//                 </form>
//               )}

//               {/* ——— Payment ——— */}
//               {activeTab === "Payment" && (
//                 <div className="space-y-8">
//                   {/* 1) Centered icon + message */}
//                   <div className="text-center py-12">
//                     <p className="mt-4 text-gray-700">
//                       Total Annual Fees to be paid:
//                       <span className="ml-1 font-medium">₹5000</span>
//                     </p>
//                   </div>

//                   {/* 2) No mx-auto or max-w on the form = full-width, left-aligned */}
//                   <form onSubmit={handlePayment} className="space-y-2">
//                     {/* 3) Input at the left, flex-1 spacer, then centered button */}
//                     <div className="flex items-center">
//                       {/* this empty flex-1 div takes all the remaining space */}
//                       <div className="flex-1 flex justify-center">
//                         <button
//                           type="submit"
//                           className="px-6 py-2 bg-blue-500 text-white font-medium rounded-full hover:bg-blue-600"
//                         >
//                           Check Status
//                         </button>
//                       </div>
//                     </div>
//                   </form>
//                 </div>
//               )}

//               {/* ——— Approval ——— */}
//               {activeTab === "Approval" && (
//                 <div className="space-y-8">
//                   {/* 1) Centered icon + message */}
//                   <div className="text-center py-12">
//                     <img
//                       src={ClipboardDocumentListIcon}
//                       className="mx-auto w-12 h-12 text-orange-400"
//                     />
//                     <p className="mt-4 text-gray-700">
//                       Your application has been forwarded to the Sub Registrar
//                       Office for further approval. Please wait while we verify
//                       your details.
//                     </p>
//                   </div>

//                   {/* 2) No mx-auto or max-w on the form = full-width, left-aligned */}
//                   <form onSubmit={handleCheckStatus} className="space-y-2">
//                     <h3 className="text-sm font-medium text-gray-700">
//                       Check Your Approval Status
//                     </h3>

//                     {/* 3) Input at the left, flex-1 spacer, then centered button */}
//                     <div className="flex items-center">
//                       <input
//                         type="text"
//                         placeholder="Enter"
//                         value={approvalId}
//                         onChange={(e) => setApprovalId(e.target.value)}
//                         className="w-1/4 border-b-2 border-gray-300 focus:outline-none focus:ring-0 py-2"
//                       />

//                       {/* this empty flex-1 div takes all the remaining space */}
//                       <div className="flex-1 flex m-4">
//                         <button
//                           type="submit"
//                           className="px-6 py-2 bg-blue-500 text-white font-medium rounded-full hover:bg-blue-600"
//                         >
//                           Check Status
//                         </button>
//                       </div>
//                     </div>
//                   </form>
//                 </div>
//               )}

//               {/* Account Details */}
//               {activeTab === "Account Details" && (
//                 <form onSubmit={handleSubmit} className="space-y-6">
//                   <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:w-1/2">
//                     {renderInput(
//                       "Enter Username",
//                       "accountUsername",
//                       "username"
//                     )}
//                     {renderInput(
//                       "Enter Password",
//                       "accountPaswword",
//                       "paswword"
//                     )}
//                     {renderInput(
//                       "Enter Confirm Password",
//                       "accountConfirmPassword",
//                       "confirmpassword"
//                     )}
//                   </div>

//                   <div className="flex justify-center space-x-4 mt-6">
//                     <button
//                       type="button"
//                       onClick={handlePrevious}
//                       className="w-32 py-2 border-2 border-blue-500 text-blue-500 rounded-full"
//                     >
//                       Previous
//                     </button>
//                     <button
//                       type="submit"
//                       className="w-32 py-2 bg-blue-500 text-white font-medium rounded-full hover:bg-blue-600"
//                     >
//                       Submit
//                     </button>
//                   </div>
//                 </form>
//               )}
//             </div>
//           </div>
//         </div>
//         <Footer />
//       </div>
//     </>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import { useForm, FormProvider, Controller } from "react-hook-form";
import axios from "axios";
import { CloudArrowUpIcon } from "@heroicons/react/24/solid";
import ServiceProvider from "../../Images/Service Provider.png";
import ClipboardDocumentListIcon from "../../Images/ClipboardDocumentListIcon.png";
import LandingNavbar from "../navbar/LandingNavbar";
import Footer from "../../pages/Footer";

const tabs = [
  "Basic Details",
  "Service Details",
  "ekyc",
  "Video ekyc",
  "Payment",
  "Approval",
  "Account Details",
];

export default function ServiceProviderSignupForm() {
  // --- react-hook-form setup ---
  const methods = useForm({
    defaultValues: {
      // Basic Details
      firstName: "",
      middleName: "",
      lastName: "",
      gender: "",
      dob: "",
      mobile: "",
      whatsapp: "",
      email: "",
      idType: "",
      idNo: "",
      relation: "",
      relatedFullName: "",
      category: "",
      religion: "",
      country: "",
      district: "",
      state: "",
      city: "",
      house: "",
      landmark: "",
      street: "",
      pincode: "",
      domicile: null,
      idCard: null,
      document1: null,
      document2: null,
      // Service Details
      workDistrict: "",
      sro: "",
      licenseNo: "",
      renewYear: "",
      convicted: "",
      convictionDetails: "",
      declaration: false,
      certificate: null,
      photo: null,
      // eKYC
      aadhaar: "",
      consentAuth: false,
      understand: false,
      otp0: "",
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
      // Video eKYC
      videoMobile: "",
      videoEmail: "",
      // Payment
      paymentRef: "",
      // Approval
      approvalId: "",
      // Account Details
      accountUsername: "",
      accountPassword: "",
      accountConfirmPassword: "",
    },
  });
  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = methods;
  const inputs = useRef([]);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [otpTimer, setOtpTimer] = useState(60);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [otpInput, setOtpInput] = useState("");

  // OTP countdown
  useEffect(() => {
    let interval;
    if (isTimerActive && otpTimer > 0) {
      interval = setInterval(() => setOtpTimer((t) => t - 1), 1000);
    } else if (otpTimer === 0) {
      setIsTimerActive(false);
    }
    return () => clearInterval(interval);
  }, [isTimerActive, otpTimer]);

  const sendOtp = () => {
    // TODO: integrate Aadhaar OTP API
    setOtpTimer(60);
    setIsTimerActive(true);
  };
  const submitOtp = () => {
    // TODO: verify OTP
    const otp =
      watch("otp0") +
      watch("otp1") +
      watch("otp2") +
      watch("otp3") +
      watch("otp4") +
      watch("otp5");
    console.log("Verifying OTP:", otp);
  };
  const formatTimer = () => {
    const m = String(Math.floor(otpTimer / 60)).padStart(2, "0");
    const s = String(otpTimer % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const sendVideoLink = async () => {
    const mobile = watch("videoMobile"),
      email = watch("videoEmail");
    // TODO: hook up your Video eKYC API here
    await axios.post("/api/video-ekyc-link", { mobile, email });
    console.log("Video link sent to:", mobile, email);
  };

  // --- Tab submit handlers ---
  const onBasicDetailsSubmit = async (data) => {
    await axios.post("/api/basic-details", data);
    setActiveTab("Service Details");
  };
  const onServiceDetailsSubmit = async (data) => {
    await axios.post("/api/service-details", data);
    setActiveTab("ekyc");
  };
  const onEkycSubmit = async (data) => {
    await axios.post("/api/ekyc", {
      aadhaar: data.aadhaar,
      consentAuth: data.consentAuth,
      understand: data.understand,
    });
    setActiveTab("Video ekyc");
  };
  const onVideoEkycSubmit = async (data) => {
    await axios.post("/api/video-ekyc-verify", {
      mobile: data.videoMobile,
      email: data.videoEmail,
    });
    setActiveTab("Payment");
  };
  const onPaymentSubmit = async (data) => {
    // await axios.post("/api/payment-status", { ref: data.paymentRef });
    console.log(data);
    setActiveTab("Approval");
  };
  const onApprovalSubmit = async (data) => {
    await axios.post("/api/approval-status", { id: data.approvalId });
    setActiveTab("Account Details");
  };
  const onAccountDetailsSubmit = async (data) => {
    await axios.post("/api/account-details", {
      username: data.accountUsername,
      password: data.accountPassword,
    });
    alert("All done!");
  };

  const handlePrevious = () => {
    const idx = tabs.indexOf(activeTab);
    if (idx > 0) setActiveTab(tabs[idx - 1]);
  };

  const handleInputChange = (index, e) => {
    const digit = e.target.value.slice(-1);

    if (/^\d$/.test(digit)) {
      // Update the visible value
      inputs.current[index].value = digit;

      // Update form state
      setValue(`otp${index}`, digit, { shouldValidate: true });

      // Move focus to the next input
      for (let i = index + 1; i < inputs.current.length; i++) {
        if (inputs.current[i].value === "") {
          inputs.current[i].focus();
          break;
        }
      }
    } else {
      inputs.current[index].value = "";
      setValue(`otp${index}`, "", { shouldValidate: true });
    }

    // Update OTP state
    const otpVal = inputs.current.map((input) => input?.value || "").join("");
    setOtpInput(otpVal);
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (inputs.current[index].value === "" && index > 0) {
        inputs.current[index - 1].focus();
      } else {
        inputs.current[index].value = "";
        setValue(`otp${index}`, "", { shouldValidate: true });
        e.preventDefault();
      }
    }
  };

  return (
    <>
      <LandingNavbar />
      <div className="flex flex-col min-h-screen w-full bg-gray-50">
        <div className="flex-1 overflow-auto py-6">
          <div className="w-full max-w-full mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-lg shadow p-6">
              {/* Header & Tabs */}
              <div className="flex items-center mb-6">
                <img
                  src={ServiceProvider}
                  alt="Service Provider"
                  className="w-12 h-12 bg-blue-100 rounded-full p-1"
                />
                <h2 className="ml-4 text-2xl font-semibold">
                  Create New Account As:{" "}
                  <span className="font-bold">Service Provider</span>
                </h2>
              </div>
              <nav className="border-b mb-8">
                <ul className="flex space-x-4 -mb-px">
                  {tabs.map((tab) => (
                    <li key={tab}>
                      <button
                        onClick={() => setActiveTab(tab)}
                        className={`pb-2 text-sm font-medium ${
                          activeTab === tab
                            ? "border-b-2 border-blue-500 text-blue-600"
                            : "text-gray-500 hover:text-gray-700"
                        }`}
                      >
                        {tab}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>

              <FormProvider {...methods}>
                {/* ——— Basic Details ——— */}
                {activeTab === "Basic Details" && (
                  <form
                    onSubmit={handleSubmit(onBasicDetailsSubmit)}
                    className="space-y-8"
                  >
                    {/* Row 1 */}
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                      <div>
                        <label className="block text-sm">First Name</label>
                        <input
                          {...register("firstName", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.firstName && (
                          <p className="text-red-500 text-xs">
                            First name is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm">Middle Name</label>
                        <input
                          {...register("middleName")}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                      </div>
                      <div>
                        <label className="block text-sm">Last Name</label>
                        <input
                          {...register("lastName", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.lastName && (
                          <p className="text-red-500 text-xs">
                            Last name is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm">Gender</label>
                        <select
                          {...register("gender", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        >
                          <option value="">Select</option>
                          <option>Male</option>
                          <option>Female</option>
                          <option>Other</option>
                        </select>
                        {errors.gender && (
                          <p className="text-red-500 text-xs">
                            Gender is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm">Date of Birth</label>
                        <input
                          type="date"
                          {...register("dob", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.dob && (
                          <p className="text-red-500 text-xs">
                            DOB is required
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Row 2 */}
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                      <div>
                        <label className="block text-sm">Mobile No.</label>
                        <input
                          {...register("mobile", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.mobile && (
                          <p className="text-red-500 text-xs">
                            Mobile is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm">WhatsApp No.</label>
                        <input
                          {...register("whatsapp")}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                      </div>
                      <div>
                        <label className="block text-sm">Email ID</label>
                        <input
                          type="email"
                          {...register("email", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.email && (
                          <p className="text-red-500 text-xs">
                            Email is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm">ID Type</label>
                        <select
                          {...register("idType", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        >
                          <option value="">Select</option>
                          <option>Passport</option>
                          <option>Aadhaar</option>
                          <option>Driver License</option>
                        </select>
                        {errors.idType && (
                          <p className="text-red-500 text-xs">
                            ID type is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm">ID No.</label>
                        <input
                          {...register("idNo", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.idNo && (
                          <p className="text-red-500 text-xs">
                            ID number is required
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Row 3 */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      <div>
                        <label className="block text-sm">Relation Type</label>
                        <input
                          {...register("relation")}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                      </div>
                      <div>
                        <label className="block text-sm">Full Name</label>
                        <input
                          {...register("relatedFullName")}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                      </div>
                      <div>
                        <label className="block text-sm">Category</label>
                        <select
                          {...register("category")}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        >
                          <option value="">Select</option>
                          <option>Cat A</option>
                          <option>Cat B</option>
                          <option>Cat C</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm">Religion</label>
                        <select
                          {...register("religion")}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        >
                          <option value="">Select</option>
                          <option>Hindu</option>
                          <option>Muslim</option>
                          <option>Christian</option>
                          <option>Other</option>
                        </select>
                      </div>
                    </div>

                    {/* Address */}
                    <div>
                      <h3 className="font-medium">Address Details:</h3>
                      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-2">
                        {["country", "district", "state", "city", "house"].map(
                          (field) => (
                            <div key={field}>
                              <label className="block text-sm capitalize">
                                {field}
                              </label>
                              <input
                                {...register(field, { required: true })}
                                className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                              />
                              {errors[field] && (
                                <p className="text-red-500 text-xs">{`${field} is required`}</p>
                              )}
                            </div>
                          )
                        )}
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                        {["landmark", "street", "pincode"].map((field) => (
                          <div key={field}>
                            <label className="block text-sm capitalize">
                              {field}
                            </label>
                            <input
                              {...register(field)}
                              className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                            />
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* File Uploads */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      {[
                        ["domicile", "Upload Domicile"],
                        ["idCard", "Upload ID Card"],
                        ["document1", "Upload Document 1"],
                        ["document2", "Upload Document 2"],
                      ].map(([name, label]) => (
                        <Controller
                          key={name}
                          name={name}
                          control={control}
                          render={({ field }) => (
                            <label className="relative w-full h-12 border-2 border-dashed border-blue-200 rounded-lg flex items-center justify-between px-4 cursor-pointer">
                              <span
                                className={`text-sm ${
                                  field.value
                                    ? "text-gray-700"
                                    : "text-blue-500"
                                }`}
                              >
                                {field.value?.name || label}
                              </span>
                              <div className="p-2 bg-blue-100 rounded">
                                <CloudArrowUpIcon className="w-4 h-4 text-blue-500" />
                              </div>
                              <input
                                type="file"
                                className="absolute inset-0 w-full h-full opacity-0"
                                onChange={(e) =>
                                  field.onChange(e.target.files[0])
                                }
                              />
                            </label>
                          )}
                        />
                      ))}
                    </div>

                    <div className="flex justify-center">
                      <button className="px-8 py-2 bg-blue-500 text-white rounded-full">
                        Next
                      </button>
                    </div>
                  </form>
                )}

                {/* ——— Service Details ——— */}
                {activeTab === "Service Details" && (
                  <form
                    onSubmit={handleSubmit(onServiceDetailsSubmit)}
                    className="space-y-6"
                  >
                    <h3 className="font-medium">Work Place:</h3>
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                      <div>
                        <label className="block text-sm">District</label>
                        <select
                          {...register("workDistrict", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          <option value="A">A</option>
                          <option value="B">B</option>
                          <option value="C">C</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm">SRO</label>
                        <select
                          {...register("sro", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          <option value="SRO1">SRO1</option>
                          <option value="SRO2">SRO2</option>
                          <option value="SRO3">SRO3</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm">License No.</label>
                        <input
                          {...register("licenseNo", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                      </div>
                      <div>
                        <label className="block text-sm">Renew Year</label>
                        <input
                          type="date"
                          {...register("renewYear", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                      </div>
                    </div>

                    <fieldset>
                      <legend className="font-medium mb-2">
                        Convicted of an offense or removed from service?
                      </legend>
                      <div className="flex space-x-6 mb-2">
                        {["yes", "no"].map((opt) => (
                          <label key={opt} className="inline-flex items-center">
                            <input
                              {...register("convicted", { required: true })}
                              type="radio"
                              value={opt}
                              className="form-radio h-4 w-4 text-blue-600"
                            />
                            <span className="ml-2 capitalize">{opt}</span>
                          </label>
                        ))}
                      </div>
                      {watch("convicted") === "yes" && (
                        <textarea
                          {...register("convictionDetails", { required: true })}
                          rows={3}
                          placeholder="Please give details"
                          className="w-full p-2 border rounded-md"
                        />
                      )}
                      {errors.convicted && (
                        <p className="text-red-500 text-xs">
                          Please select an option
                        </p>
                      )}
                    </fieldset>

                    <label className="flex items-start space-x-2">
                      <input
                        type="checkbox"
                        {...register("declaration")}
                        className="form-checkbox h-5 w-5 text-blue-600"
                      />
                      <span className="text-sm">
                        I declare that I have read the licensing rules and agree
                        to abide by them.
                      </span>
                    </label>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      {[
                        ["certificate", "Upload Certificate"],
                        ["photo", "Upload Photo"],
                      ].map(([name, label]) => (
                        <Controller
                          key={name}
                          name={name}
                          control={control}
                          render={({ field }) => (
                            <label className="relative w-full h-12 border-2 border-dashed border-blue-200 rounded-lg flex items-center justify-between px-4 cursor-pointer">
                              <span
                                className={`text-sm ${
                                  field.value
                                    ? "text-gray-700"
                                    : "text-blue-500"
                                }`}
                              >
                                {field.value?.name || label}
                              </span>
                              <div className="p-2 bg-blue-100 rounded">
                                <CloudArrowUpIcon className="w-4 h-4 text-blue-500" />
                              </div>
                              <input
                                type="file"
                                className="absolute inset-0 w-full h-full opacity-0"
                                onChange={(e) =>
                                  field.onChange(e.target.files[0])
                                }
                              />
                            </label>
                          )}
                        />
                      ))}
                    </div>

                    <div className="flex justify-center space-x-4">
                      <button
                        type="button"
                        onClick={handlePrevious}
                        className="px-6 py-2 border-2 border-blue-500 text-blue-500 rounded-full"
                      >
                        Previous
                      </button>
                      <button className="px-6 py-2 bg-blue-500 text-white rounded-full">
                        Next
                      </button>
                    </div>
                  </form>
                )}

                {/* ——— eKYC ——— */}
                {activeTab === "ekyc" && (
                  <form
                    onSubmit={handleSubmit(onEkycSubmit)}
                    className="space-y-6"
                  >
                    <div className="w-1/3">
                      <label className="block text-sm">
                        Enter Your Aadhaar no.
                      </label>
                      <input
                        {...register("aadhaar", { required: true })}
                        className="mt-1 w-full border-b-2 border-gray-300 focus:ring-0 py-2"
                      />
                      {errors.aadhaar && (
                        <p className="text-red-500 text-xs">
                          Aadhaar is required
                        </p>
                      )}
                      <button
                        type="button"
                        onClick={sendOtp}
                        disabled={isTimerActive}
                        className={`mt-2 px-6 py-2 rounded-full font-medium ${
                          isTimerActive
                            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                            : "bg-blue-500 text-white hover:bg-blue-600"
                        }`}
                      >
                        Send OTP
                      </button>
                    </div>

                    <div className="bg-gray-100 p-4 rounded space-y-3 text-sm text-gray-700">
                      <label className="flex items-start">
                        <input
                          type="checkbox"
                          {...register("consentAuth")}
                          className="mt-1 h-4 w-4 text-blue-600"
                        />
                        <span className="ml-2">
                          I Hereby State That I Have No Objection In
                          Authentication Myself With Aadhaar Based
                          Authentication System and Consent to Providing My
                          Aadhaar Number, Biometric and/or One-time Password
                          (OTP) Data for Aadhaar Based Authentication for the
                          Purposes of Availing Benefits of E-registration and
                          E-stamp. I understand That the Aadhaar Number,
                          Biometric and/or OTP I Provide for Authentication
                          Shall Be Used
                          <ol className="list-decimal list-inside ml-4 mt-2">
                            <li>For Authenticating My Identity</li>
                            <li>For Authenticating Property Ownership</li>

                            <li>
                              For De-Duplication within Verticals of IGRS
                              (Inspector General of Registration and Stamps) and
                              Other Integrated Departments (UADD (Directorate of
                              Urban Administration), CLR (Commissioner Land
                              Records and Settlement))
                            </li>
                          </ol>
                        </span>
                      </label>
                      <label className="flex items-start">
                        <input
                          type="checkbox"
                          {...register("understand")}
                          className="mt-1 h-4 w-4 text-blue-600"
                        />
                        <span className="ml-2">
                          I understand that IGRS (Inspector General of
                          Registration and Stamps), UADD (Directorate of Urban
                          Administration), CLR (Commissioner Land Records and
                          Settlement) and T&CP (Director of Town and Country
                          Planning) shall ensure security and confidentiality of
                          my personal identity data provided for the purpose of
                          Aadhaar based authentication
                        </span>
                      </label>
                    </div>

                    <div className="space-y-4">
                      <label className="block text-sm">Enter OTP</label>
                      {/* <div className="flex space-x-2">
                        {Array.from({ length: 6 }).map((_, idx) => (
                          <input
                            key={idx}
                            {...register(`otp${idx}`, {
                              required: true,
                              maxLength: 1,
                            })}
                            className="w-12 h-12 text-center border-b-2 border-gray-300 focus:ring-0"
                          />
                        ))}
                      </div> */}
                      <div className="flex space-x-2 mb-4">
                        {Array.from({ length: 6 }).map((_, idx) => (
                          <input
                            key={idx}
                            type="text"
                            maxLength={1}
                            className="w-12 h-12 text-center border-b-2 border-gray-300 focus:ring-0"
                            {...register(`otp${idx}`, {
                              required: true,
                              maxLength: 1,
                              validate: (val) =>
                                /^\d$/.test(val) || "Invalid digit",
                            })}
                            ref={(el) => {
                              inputs.current[idx] = el;
                              register(`otp${idx}`).ref(el);
                            }}
                            onChange={(e) => handleInputChange(idx, e)}
                            onKeyDown={(e) => handleKeyDown(idx, e)}
                          />
                        ))}
                      </div>
                      <button
                        type="button"
                        onClick={submitOtp}
                        className="px-6 py-2 bg-blue-500 text-white rounded-full"
                      >
                        Submit OTP
                      </button>
                      <div className="flex items-center space-x-4 text-sm">
                        <button
                          type="button"
                          onClick={() => {
                            sendOtp();
                          }}
                          className="text-blue-500"
                        >
                          Resend OTP
                        </button>
                        <span>{formatTimer()}</span>
                      </div>
                    </div>

                    <div className="flex justify-center space-x-4">
                      <button
                        type="button"
                        onClick={handlePrevious}
                        className="px-6 py-2 border-2 border-blue-500 text-blue-500 rounded-full"
                      >
                        Previous
                      </button>
                      <button className="px-6 py-2 bg-blue-500 text-white rounded-full">
                        Verify & Next
                      </button>
                    </div>
                  </form>
                )}

                {/* ——— Video eKYC ——— */}
                {activeTab === "Video ekyc" && (
                  <form
                    onSubmit={handleSubmit(onVideoEkycSubmit)}
                    className="space-y-6"
                  >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:w-1/3">
                      <div>
                        <label className="block text-sm">
                          Enter mobile no.
                        </label>
                        <input
                          {...register("videoMobile", { required: true })}
                          className="mt-1 w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.videoMobile && (
                          <p className="text-red-500 text-xs">
                            Mobile No. is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm">Enter Email Id</label>
                        <input
                          type="email"
                          {...register("videoEmail", { required: true })}
                          className="mt-1 w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.videoEmail && (
                          <p className="text-red-500 text-xs">
                            Email is required
                          </p>
                        )}
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={sendVideoLink}
                      className="px-6 py-2 bg-blue-500 text-white rounded-full"
                    >
                      Send Video eKYC link
                    </button>
                    <div className="flex justify-center space-x-4">
                      <button
                        type="button"
                        onClick={handlePrevious}
                        className="px-6 py-2 border-2 border-blue-500 text-blue-500 rounded-full"
                      >
                        Previous
                      </button>
                      <button className="px-6 py-2 bg-blue-500 text-white rounded-full">
                        Verify & Next
                      </button>
                    </div>
                  </form>
                )}

                {/* ——— Payment ——— */}
                {activeTab === "Payment" && (
                  <form
                    onSubmit={handleSubmit(onPaymentSubmit)}
                    className="space-y-8"
                  >
                    <div className="text-center py-12">
                      <p className="text-gray-700">
                        Total Annual Fees to be paid:
                        <span className="ml-1 font-medium">₹5000</span>
                      </p>
                    </div>
                    <div className="flex items-center space-x-4 justify-center">
                      {/* <input
                        {...register("paymentRef", { required: true })}
                        placeholder="Enter Payment Ref"
                        className="w-1/3 border-b-2 border-gray-300 focus:ring-0 py-2"
                      /> */}
                      <button className="px-6 py-2 bg-blue-500 text-white rounded-full">
                        Check Status
                      </button>
                    </div>
                    {errors.paymentRef && (
                      <p className="text-red-500 text-center text-xs">
                        Payment reference is required
                      </p>
                    )}
                  </form>
                )}

                {/* ——— Approval ——— */}
                {activeTab === "Approval" && (
                  <form
                    onSubmit={handleSubmit(onApprovalSubmit)}
                    className="space-y-8"
                  >
                    <div className="text-center py-12">
                      <img
                        src={ClipboardDocumentListIcon}
                        alt=""
                        className="mx-auto w-12 h-12"
                      />
                      <p className="mt-4 text-gray-700">
                        Your application is pending approval. Check status:
                      </p>
                    </div>
                    <div className="flex items-center space-x-4">
                      <input
                        {...register("approvalId", { required: true })}
                        placeholder="Enter Approval ID"
                        className="w-1/4 border-b-2 border-gray-300 focus:ring-0 py-2"
                      />
                      <button className="px-6 py-2 bg-blue-500 text-white rounded-full">
                        Check Status
                      </button>
                    </div>
                    {errors.approvalId && (
                      <p className="text-red-500 text-xs">
                        Approval ID is required
                      </p>
                    )}
                  </form>
                )}

                {/* ——— Account Details ——— */}
                {activeTab === "Account Details" && (
                  <form
                    onSubmit={handleSubmit(onAccountDetailsSubmit)}
                    className="space-y-6"
                  >
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:w-1/2">
                      <div>
                        <label className="block text-sm">Username</label>
                        <input
                          {...register("accountUsername", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.accountUsername && (
                          <p className="text-red-500 text-xs">
                            Username is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm">Password</label>
                        <input
                          type="password"
                          {...register("accountPassword", { required: true })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.accountPassword && (
                          <p className="text-red-500 text-xs">
                            Password is required
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm">
                          Confirm Password
                        </label>
                        <input
                          type="password"
                          {...register("accountConfirmPassword", {
                            required: true,
                            validate: (v) =>
                              v === watch("accountPassword") ||
                              "Passwords must match",
                          })}
                          className="mt-1 block w-full border-b-2 border-gray-300 focus:ring-0"
                        />
                        {errors.accountConfirmPassword && (
                          <p className="text-red-500 text-xs">
                            {errors.accountConfirmPassword.message}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="flex justify-center space-x-4">
                      <button
                        type="button"
                        onClick={handlePrevious}
                        className="px-6 py-2 border-2 border-blue-500 text-blue-500 rounded-full"
                      >
                        Previous
                      </button>
                      <button className="px-6 py-2 bg-blue-500 text-white rounded-full">
                        Submit
                      </button>
                    </div>
                  </form>
                )}
              </FormProvider>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
